{
  "version": 1,
  "asset_id": "f8654c0a-5a33-4846-8cd2-c65bbc666a47",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/f8654c0a-5a33-4846-8cd2-c65bbc666a47/ind-security-automation-640.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/f8654c0a-5a33-4846-8cd2-c65bbc666a47/ind-security-automation-640.avif",
  "original_filename": "ind-security-automation-640.avif",
  "size": 3467,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:15Z"
}
